import type React from 'react';

interface NotiOffProps {
  size?: number;
  fill?: string;
  className?: string;
}

const NotiOff: React.FC<NotiOffProps> = ({ size = 24, fill = '#000000', className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M10.0498 18C10.1877 18.3812 10.4271 18.7203 10.7441 18.9795C11.1471 19.3087 11.6515 19.4893 12.1719 19.4893C12.6922 19.4892 13.1967 19.3088 13.5996 18.9795C13.9166 18.7203 14.1561 18.3812 14.2939 18H15.958C15.8389 18.5864 15.5862 19.1333 15.2236 19.5996C15.0475 19.8262 14.8452 20.0347 14.6201 20.2188C13.9315 20.7816 13.0681 21.0888 12.1787 21.0889C11.2894 21.0888 10.4269 20.7815 9.73828 20.2188C9.51316 20.0347 9.31097 19.8262 9.13477 19.5996C8.77218 19.1332 8.5195 18.5865 8.40039 18H10.0498Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1807 3C13.5848 3.00013 14.9441 3.45726 16.0625 4.30176L16.0664 4.30469C16.4145 4.57138 16.742 4.9066 17.04 5.2793L18.3203 4L19.3809 5.06055L5.06055 19.3809L4 18.3203L5.5625 16.7568C5.46707 16.7242 5.37211 16.686 5.2793 16.6387C4.92417 16.4725 4.64862 16.2189 4.44629 15.9443L4.43457 15.9287C4.2279 15.6334 4.0925 15.3035 4.03223 14.957C3.96845 14.5903 4.00316 14.2229 4.10547 13.8867V13.8838L5.95898 7.87695C6.29227 6.5214 7.05413 5.29404 8.16211 4.41406C9.30196 3.50281 10.7176 3 12.1807 3ZM12.1807 4.59961C11.0846 4.59961 10.02 4.97726 9.16016 5.66504L9.1582 5.66699C8.33371 6.32148 7.7577 7.24439 7.50781 8.27832L7.50195 8.30176L5.63574 14.3525V14.3545C5.59849 14.4776 5.59232 14.5898 5.6084 14.6826C5.62761 14.793 5.67041 14.9008 5.74023 15.0029C5.81228 15.0984 5.88903 15.1583 5.96191 15.1914L5.98145 15.2012L6.00195 15.2109C6.08369 15.2537 6.18369 15.2803 6.31055 15.2803H7.04004L15.8984 6.4209C15.6475 6.08532 15.3744 5.79108 15.0957 5.57715C14.2549 4.94299 13.2351 4.59974 12.1807 4.59961Z"
        fill={fill}
      />
      <path
        d="M18.2471 7.35938C18.3228 7.54918 18.3894 7.73623 18.4443 7.91797L20.5518 13.7861L20.5527 13.7881C20.6749 14.1248 20.7197 14.502 20.6738 14.8691C20.6272 15.242 20.4879 15.5947 20.2754 15.8984C20.0636 16.201 19.7841 16.4531 19.4385 16.626C19.1157 16.7873 18.7535 16.8797 18.3809 16.8799H8.72754L10.3271 15.2803H18.3809C18.4877 15.2801 18.6059 15.2527 18.7227 15.1943C18.8167 15.1473 18.8968 15.0786 18.9648 14.9814C19.0321 14.8853 19.0735 14.7778 19.0869 14.6709C19.1009 14.5588 19.0862 14.4358 19.0488 14.333L19.0479 14.3301L16.9932 8.61328L18.2471 7.35938Z"
        fill={fill}
      />
    </svg>
  );
};

export default NotiOff;
